import React from 'react';

const Payroll = (props: React.PropsWithChildren<React.SVGProps<SVGSVGElement>>) => (
  <svg
    {...props}
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    role="img"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M45.375 17.625H3.375" stroke="black" strokeWidth="2" strokeLinecap="square" />
    <path
      d="M28.125 42.375H7.125C6.13044 42.375 5.17661 41.9799 4.47335 41.2767C3.77009 40.5734 3.375 39.6196 3.375 38.625V10.875C3.375 9.88044 3.77009 8.92661 4.47335 8.22335C5.17661 7.52009 6.13044 7.125 7.125 7.125H41.625C42.6196 7.125 43.5734 7.52009 44.2767 8.22335C44.9799 8.92661 45.375 9.88044 45.375 10.875V25.875"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="square"
    />
    <path d="M13.125 2.625V11.625" stroke="black" strokeWidth="2" strokeLinecap="square" />
    <path d="M35.625 2.625V11.625" stroke="black" strokeWidth="2" strokeLinecap="square" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M33.3464 29.3638C31.7975 30.1383 31.125 31.0695 31.125 31.875C31.125 32.6805 31.7975 33.6117 33.3464 34.3862C34.8505 35.1382 36.9809 35.625 39.375 35.625C41.7691 35.625 43.8995 35.1382 45.4036 34.3862C46.9525 33.6117 47.625 32.6805 47.625 31.875C47.625 31.0695 46.9525 30.1383 45.4036 29.3638C43.8995 28.6118 41.7691 28.125 39.375 28.125C36.9809 28.125 34.8505 28.6118 33.3464 29.3638ZM47.625 37.125V34.7222C47.173 35.1065 46.644 35.443 46.0744 35.7278C44.3211 36.6044 41.9515 37.125 39.375 37.125C36.7985 37.125 34.4289 36.6044 32.6756 35.7278C32.106 35.443 31.577 35.1065 31.125 34.7222V37.125V37.875C31.125 38.6806 31.7976 39.6118 33.3466 40.3862C34.8507 41.1383 36.9811 41.625 39.375 41.625C41.7689 41.625 43.8993 41.1383 45.4034 40.3862C46.9524 39.6118 47.625 38.6806 47.625 37.875V37.125ZM31.125 40.7222V43.875C31.125 44.6806 31.7976 45.6118 33.3466 46.3862C34.8507 47.1383 36.9811 47.625 39.375 47.625C41.7689 47.625 43.8993 47.1383 45.4034 46.3862C46.9524 45.6118 47.625 44.6806 47.625 43.875V40.7222C47.1729 41.1066 46.6439 41.4431 46.0742 41.7279C44.3209 42.6045 41.9513 43.125 39.375 43.125C36.7987 43.125 34.4291 42.6045 32.6758 41.7279C32.1061 41.4431 31.5771 41.1066 31.125 40.7222Z"
      fill="#FB6121"
    />
  </svg>
);

export default Payroll;
